import {
	DialogInfo,
	DynamicInfo,
	LoginInfo,
	PrivilegesInfo,
	PromptInfo,
} from "@/types";
import { signal } from "@preact/signals";

export const arePopupsOpen = signal({
	privileges: false,
});
export const currentPrivilegesInfo = signal<PrivilegesInfo>({});
export const dialog = signal<DialogInfo>({});
export const dynamicInfo = signal<DynamicInfo>({});
export const isCaptchaShown = signal(false);
export const isLoadingScreenShown = signal<boolean>(
	window.location.pathname !== "/login",
);
export const login = signal<LoginInfo>({});
export const prompt = signal<PromptInfo>({});
